import { push } from 'connected-react-router';

export const viewCompany = (companyId, descriptor) => dispatch =>
    dispatch(push(`/company/${companyId}${descriptor ? '/' : ''}${descriptor ? descriptor : ''}`));
